import { storage } from '../lib/storage';

export const createBackup = async (walletAddress: string) => {
  try {
    // Get all conversations
    const conversations = await storage.getConversations(walletAddress);
    
    // Get all messages from all conversations
    const allMessages = [];
    for (const conversation of conversations) {
      const messages = await storage.getConversationMessages(walletAddress, conversation.id);
      allMessages.push(...messages);
    }

    const backup = {
      conversations,
      messages: allMessages,
      timestamp: new Date().toISOString(),
      walletAddress
    };

    return backup;
  } catch (error) {
    console.error('Error creating backup:', error);
    throw error;
  }
};

export const restoreBackup = async (walletAddress: string, backupData: any) => {
  try {
    if (!backupData?.conversations || !backupData?.messages || !Array.isArray(backupData.conversations) || !Array.isArray(backupData.messages)) {
      throw new Error('Invalid backup data format');
    }

    // Get existing conversations to avoid duplicates
    const existingConversations = await storage.getConversations(walletAddress);
    const existingConversationIds = new Set(existingConversations.map(c => c.id));

    // Get existing messages to avoid duplicates
    const existingMessages = new Set<string>();
    for (const conv of existingConversations) {
      const messages = await storage.getConversationMessages(walletAddress, conv.id);
      messages.forEach(msg => existingMessages.add(msg.id));
    }

    // Store new messages first
    const newMessages = backupData.messages.filter((msg: any) => !existingMessages.has(msg.id));
    for (const message of newMessages) {
      await storage.setMessage(message.id, message);
    }

    // Store new conversations
    const newConversations = backupData.conversations.filter((conv: any) => !existingConversationIds.has(conv.id));
    for (const conversation of newConversations) {
      await storage.setConversation(walletAddress, conversation);
    }

    return {
      newConversations: newConversations.length,
      newMessages: newMessages.length
    };
  } catch (error) {
    console.error('Error restoring backup:', error);
    throw error;
  }
};
